import { render, staticRenderFns } from "./Zoho.vue?vue&type=template&id=17b5b48c&scoped=true"
import script from "./Zoho.vue?vue&type=script&lang=js"
export * from "./Zoho.vue?vue&type=script&lang=js"
import style0 from "./Zoho.vue?vue&type=style&index=0&id=17b5b48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b5b48c",
  null
  
)

export default component.exports